<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-row>
                <el-col :span="16">
                  <span class="cs-title">真留任务分配</span>
                </el-col>
              </el-row>
              <el-row class="margin-top-10">
                <el-col :span="4">
                  <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search" v-model.trim="searchCondition.phone"
                    @keyup.enter.native="onSearchConditionChanged()"></el-input>
                </el-col>
                <el-col :span="4">
                  <el-select placeholder="所有大学" filterable v-model="searchCondition.universityId" size="medium" class="margin-left-20px">
                    <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key" />
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-select placeholder="所有分配状态" filterable v-model="searchCondition.taskAssignmentStatus" size="medium" class="margin-left-20px">
                    <el-option :key="-1" label="所有分配状态" :value="-1" />
                    <el-option v-for="item in GLOBAL.enumTaskAssignmentStatus.getOptions()" :key="item.value" :label="item.desc" :value="item.value" />
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-select placeholder="所有负责人员" filterable v-model="searchCondition.responsiblePersonId" size="medium" class="margin-left-20px">
                    <el-option v-for="item in employeeList" :key="item.Id" :label="item.Name" :value="item.Id" />
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <div class="cs-studentTotal margin-left-20px">真留人员人数：{{listData.RecordCount}}</div>
                </el-col>
                <el-col :span="4" class="cs-saleQuery-buttons">
                  <el-button size="medium" type="primary" class="margin-left-20px" @click="onSearchConditionChanged()">搜索</el-button>
                </el-col>
              </el-row>
              <el-row class="grid-content">
                <pagination v-loading="isLoading" :data="listData" :option="paginationOption" @loadData="onLoadList" @pageSizeChange="pageSizeChange"
                  @currentPageChange="currentPageChange" @edit="onEdit"></pagination>
              </el-row>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUniversities } from "@/service/common.service";
import {
  getSAEmployees,
  getSATaskAssignmentStudentList,
} from "@/service/studyAbroad.service";

const mixin_generalMethods = {
  methods: {
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      this.currentPageNumber = pageNumber;
      let additionalFilter = {
        UniversityId: this.searchCondition.universityId,
        TaskAssignmentStatus: this.searchCondition.taskAssignmentStatus,
        ResponsiblePersonId: this.searchCondition.responsiblePersonId,
      };

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchCondition.phone,
        additionalFilter: additionalFilter,
      };
      return pageData;
    },
  },
};

export default {
  name: "taskAssignment",
  mixins: [mixin_generalMethods],
  components: {
    navigator: () => import("@/components/navigator"),
    pagination: () => import("@/components/common/pagination"),
  },
  data() {
    return {
      pageSize: 20,
      currentPageNumber: 1,
      isLoading: false,
      paginationOption: {},
      universityList: [],
      employeeList: [],
      listData: {
        RecordCount: 0,
      },
      taskAssignmentStatusItems: [
        {
          key: "",
          value: -1,
          desc: "所有分配状态",
        },
      ],
      searchCondition: {
        phone: String.empty,
        universityId: 0,
        taskAssignmentStatus: -1,
        responsiblePersonId: 0,
      },
    };
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: true,
      hasAddButton: false,
      addButtonText: "",
      editButtonText: "查看分配详情",
      fnCustomCellClass: (col, row) => {
        return {
          "color-status": col.IsColorLabel,
          "color-status-completed":
            row.TaskAssignmentStatus ===
            this.GLOBAL.enumTaskAssignmentStatus.Completed,
        };
      },
    };

    this.init();
  },
  methods: {
    // 从服务端获取数据相关方法
    async loadUniversityListFromServer() {
      let dataList = [
        {
          Key: 0,
          Value: "所有学校",
        },
      ];

      try {
        let result = await getUniversities();
        if (!!result && result.success) {
          dataList = dataList.concat(result.data);
        }
      } catch (error) {}

      this.universityList = dataList;
      this.searchCondition.universityId = 0;
    },
    async loadSAEmployeeListFromServer() {
      let dataList = [
        {
          Id: 0,
          Name: "所有负责人员",
        },
      ];

      let roleTypes = [
        this.GLOBAL.roleType.saBusinessManager,
        this.GLOBAL.roleType.saBusinessAssistant,
      ];
      try {
        let result = await getSAEmployees(roleTypes, "", null);
        if (result && result.success) {
          let employeeList = result.data.Results.map((i) => {
            return { Id: i.UserId, Name: i.Name };
          });
          dataList = dataList.concat(employeeList);
        }
      } catch (error) {}

      this.employeeList = dataList;
      this.searchCondition.responsiblePersonId = 0;
    },
    async loadListDataFromServer(pageData) {
      this.isLoading = true;

      try {
        let result = await getSATaskAssignmentStudentList(pageData);
        if (!!result && result.success) {
          this.listData = result.data;
        }
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    async init() {
      await this.loadUniversityListFromServer();
      await this.loadSAEmployeeListFromServer();

      await this.search();
    },
    async search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      await this.loadListDataFromServer(pageData);
    },

    onSearchConditionChanged() {
      this.search();
    },

    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    onEdit(index, row) {
      let navList = JSON.stringify([
        {
          path: this.$route.path,
        },
      ]);

      this.$router.push({
        path: "/studyAbroad/taskAssignmentDetail",
        query: {
          studentId: row.StudentId,
          navList: this.$cryptoJS.enc.Base64.encode(navList),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ body .el-table .el-table-header th {
  height: 30px;
  padding: 5px 0px;
  color: #909399 !important;
  background-color: #fff !important;
}

.cs-contentContainer {
  .cs-studentTotal {
    height: 36px;
    line-height: 36px;
    color: #b9bfbf;
  }

  .grid-content {
    margin-top: 15px;
    /deep/ .el-table .el-table-header th {
      height: 30px;
      padding: 5px 0px;
      color: #909399 !important;
      background-color: #fff !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/studyAbroad/taskAssignment.vue